import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
import * as status from '../constants/requestStatus';
var initialState = {};
export default function assetDownload(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.DOWNLOAD_ASSETS_START:
            return updateRequestStatus(state, action, status.PENDING);
        case actionTypes.ASSETS_ZIP_CREATED:
            return updateRequestStatus(state, action, status.SUCCESS);
        case actionTypes.ASSETS_ZIP_DOWNLOADED:
            return updateRequestStatus(state, action, status.IDLE);
        default:
            return state;
    }
}
function updateRequestStatus(state, _a, requestStatus) {
    var _b, _c;
    var screenID = _a.screenID, elementID = _a.elementID, assetType = _a.assetType, requestID = _a.requestID;
    var currentStatus = state[requestID];
    var change;
    if (currentStatus) {
        change = (_b = {}, _b[requestID] = { status: { $set: requestStatus } }, _b);
    }
    else {
        change = {
            $merge: (_c = {},
                _c[requestID] = {
                    screenID: screenID,
                    elementID: elementID,
                    assetType: assetType,
                    status: requestStatus,
                },
                _c),
        };
    }
    return update(state, change);
}
